"use client";

import { FC, PropsWithChildren, useEffect } from "react";
import { useWantToBuyStore } from "@/contexts/useWantToBuy";
import { ViewFilter } from "@/libs/types/want-to-buy.type";
import { usePageLoadingStore } from "@/contexts/usePageLoading";

type WantToBuyProviderProps = PropsWithChildren & {
  data: ViewFilter;
};

const WantToBuyProvider: FC<WantToBuyProviderProps> = ({ children, data }) => {
  const initialFilter = useWantToBuyStore((state) => state.initialFilter);
  const { resetLoading } = usePageLoadingStore();

  useEffect(() => {
    initialFilter(data);
    resetLoading();
  }, [data, initialFilter, resetLoading]);

  return <>{children}</>;
};

export default WantToBuyProvider;
